import React from 'react'
import { CustomText } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import { UserSaleOffer } from 'src/core/models'
import { currencyListSelector } from 'src/features'
import styles from './SaleOfferPriceColumn.module.scss'
import { getFormatedPrice, getProjectUnit } from 'src/core/helpers'

const SaleOfferPriceColumn: React.FC<{ offer: UserSaleOffer }> = ({ offer }) => {
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c.id === offer.currency)?.code

  const amountLabel = `${offer.amount} ${getProjectUnit(offer.project_kind)}`
  const priceLabel = `${getFormatedPrice(offer.price_per_unit, currencyCode)}`

  return <div className={styles.content}>
    <CustomText label={amountLabel} />
    <CustomText label={priceLabel} />
  </div>
}

export default SaleOfferPriceColumn
